import React, { useState } from "react"
import {
  Modal, Button, Collapse, Typography,
} from "antd"
import { UpOutlined } from "@ant-design/icons"
import "./SustainabilityCSVUploadModal.css"

const { Panel } = Collapse
const { Text } = Typography

const SustainabilityCSVPreviewModal = ({
  visible,
  onClose,
  domainData,
  indicatorData,
  onConfirmUpload,
  loading,
}) => {
  const [activeKeys, setActiveKeys] = useState([])
  const [domainActiveKeys, setDomainActiveKeys] = useState([])
  const [indicatorActiveKeys, setIndicatorActiveKeys] = useState([])

  const hasDomainData = domainData && domainData.length > 0
  const hasIndicatorData = indicatorData && indicatorData.length > 0

  const handleConfirm = () => {
    if (onConfirmUpload) {
      onConfirmUpload()
    }
  }

  const getScoreText = (score) => {
    const scoreMap = {
      0: "INITIATING",
      1: "DEVELOPING",
      2: "PROFICIENT",
      3: "WELL DEVELOPED",
    }
    return scoreMap[score] || score
  }

  return (
    <Modal
      title={(
        <div>
          <div style={{ fontSize: "16px", fontWeight: 600 }}>
            Preview Sustainability Content
          </div>
          <div style={{ marginTop: "4px" }}>
            <span type="secondary" style={{ fontSize: "12px" }}>
              Review the parsed indicator content below. Click &quot;Upload
              File(s)&quot; to add this content to the corresponding fields and area.
            </span>
          </div>
        </div>
      )}
      open={visible}
      onCancel={onClose}
      centered
      footer={[
        <Button key="cancel" onClick={onClose} style={{ borderRadius: "6px" }}>
          Cancel
        </Button>,
        <Button
          key="upload"
          type="primary"
          danger
          onClick={handleConfirm}
          loading={loading}
          style={{
            width: "135px",
            height: "35px",
            borderRadius: "6px",
            backgroundColor: "#a6192e",
          }}
        >
          Upload File(s)
        </Button>,
      ]}
      width={800}
      destroyOnClose
      className="sustainability-preview-modal"
    >
      <div className="sustainability-preview-content" style={{ padding: "0" }}>
        <Collapse
          ghost
          expandIcon={({ isActive }) => (
            <UpOutlined
              rotate={isActive ? 0 : 180}
              className="main-collapse-icon"
              style={{ fontSize: "20px", color: "#a6192e", cursor: "pointer" }}
            />
          )}
          expandIconPosition="end"
          collapsible="header"
          activeKey={activeKeys}
          onChange={setActiveKeys}
          className="main-collapse-container"
          style={{
            marginTop: 20,
            padding: "0",
            overflowY: "auto",
            maxHeight: "500px",
          }}
        >
          {hasDomainData && (
            <Panel
              header={(
                <div
                  className="panel-header"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 600,
                  }}
                >
                  <span className="panel-title">Domains</span>
                </div>
              )}
              key="domains"
              className="domains-panel"
              style={{
                backgroundColor: "#F6E8EA",
                border: "1px solid #EBEDEF",
                borderRadius: 8,
                marginBottom: 8,
              }}
            >
              <Collapse
                ghost
                expandIcon={({ isActive }) => (
                  <UpOutlined
                    className="domain-collapse-icon"
                    style={{
                      fontSize: "25px",
                      color: "#b85450",
                      cursor: "pointer",
                    }}
                    rotate={isActive ? 0 : 180}
                  />
                )}
                expandIconPosition="end"
                activeKey={domainActiveKeys}
                onChange={setDomainActiveKeys}
                className="domain-collapse-container"
              >
                {domainData.map((domain, index) => (
                  <Panel
                    header={(
                      <div
                        className="domain-item-header"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="domain-item-number"
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: 3,
                            backgroundColor: "#b85450",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 8,
                            fontSize: 12,
                            fontWeight: 600,
                          }}
                        >
                          {index + 1}
                        </span>
                        <span
                          className="domain-item-title"
                          style={{ fontWeight: 500 }}
                        >
                          {domain.domain}
                        </span>
                      </div>
                    )}
                    key={`domain-${index}`}
                    className="domain-item-panel"
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: 6,
                      marginBottom: 4,
                    }}
                  >
                    <div
                      className="domain-item-content"
                      style={{
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <div className="strength-section">
                        <span
                          className="section-title-sustainability-sustainability-sustainability"
                          style={{
                            color: "#a6192e",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          Areas of Strength:
                        </span>
                        <div
                          className="section-content"
                          style={{
                            paddingLeft: 12,
                          }}
                        >
                          <Text
                            className="content-text"
                            style={{
                              fontSize: 13,
                              lineHeight: 1.6,
                            }}
                          >
                            {domain.areas_of_strength || "N/A"}
                          </Text>
                        </div>
                      </div>

                      <div className="growth-section">
                        <Text
                          className="section-title-sustainability-sustainability"
                          style={{
                            color: "#a6192e",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          Opportunities for Growth:
                        </Text>
                        <div
                          className="section-content"
                          style={{
                            paddingLeft: 12,
                          }}
                        >
                          <Text
                            className="content-text"
                            style={{
                              fontSize: 13,
                              lineHeight: 1.6,
                            }}
                          >
                            {domain.opportunities_for_growth || "N/A"}
                          </Text>
                        </div>
                      </div>
                    </div>
                  </Panel>
                ))}
              </Collapse>
            </Panel>
          )}

          {hasIndicatorData && (
            <Panel
              header={(
                <div
                  className="panel-header"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 600,
                  }}
                >
                  <span className="panel-title">Indicators</span>
                </div>
              )}
              key="indicators"
              className="indicators-panel"
              style={{
                backgroundColor: "#F6E8EA",
                border: "1px solid #EBEDEF",
                borderRadius: 8,
                marginBottom: 8,
              }}
            >
              <Collapse
                ghost
                expandIcon={({ isActive }) => (
                  <UpOutlined
                    className="domain-collapse-icon"
                    style={{
                      fontSize: "25px",
                      color: "#b85450",
                      cursor: "pointer",
                    }}
                    rotate={isActive ? 0 : 180}
                  />
                )}
                expandIconPosition="end"
                activeKey={indicatorActiveKeys}
                onChange={setIndicatorActiveKeys}
                className="indicator-collapse-container"
                style={{ borderBottom: "1px solid #EBEDEF" }}
              >
                {indicatorData.map((indicator, index) => (
                  <Panel
                    header={(
                      <div
                        className="indicator-item-header"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="indicator-item-number"
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: 3,
                            backgroundColor: "#b85450",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 8,
                            fontSize: 12,
                            fontWeight: 600,
                          }}
                        >
                          {indicator.indicator_number || index + 1}
                        </span>
                        <span
                          className="indicator-item-title"
                          style={{
                            fontWeight: 400,
                            color: "#a6192e",
                            fontSize: 14,
                          }}
                        >
                          {indicator.title
                            || `Indicator ${
                              indicator.indicator_number || index + 1
                            }`}
                        </span>
                      </div>
                    )}
                    key={`indicator-${index}`}
                    className="indicator-item-panel"
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: 6,
                      marginBottom: 4,
                    }}
                  >
                    <div
                      className="indicator-item-content"
                      style={{
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <div
                        className="score-section"
                        style={{ marginBottom: 12 }}
                      >
                        <div
                          className="section-title-sustainability"
                          style={{
                            color: "#a6192e",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          <span
                            style={{
                              paddingRight: "5px",
                            }}
                          >
                            {" "}
                            Score:
                          </span>
                          <span>{getScoreText(indicator.score)}</span>
                        </div>
                      </div>

                      {indicator.justification && (
                        <div className="justification-section">
                          <div
                            className="section-content"
                            style={{
                              paddingLeft: 12,
                            }}
                          >
                            <span
                              className="content-text"
                              style={{
                                fontSize: 13,
                                lineHeight: 1.6,
                              }}
                            >
                              {indicator.justification}
                            </span>
                            {/* {getScoreText(indicator.score)}         */}
                          </div>
                        </div>
                      )}
                    </div>
                  </Panel>
                ))}
              </Collapse>
            </Panel>
          )}
        </Collapse>
      </div>
    </Modal>
  )
}

export default SustainabilityCSVPreviewModal
